import React, { useState } from "react";
import { useEffect } from 'react';
import { FaRegFolderOpen } from 'react-icons/fa6';
import { RiFolderFill } from 'react-icons/ri';
import { HiDocumentText } from 'react-icons/hi';
import { RiFolderCheckFill } from 'react-icons/ri';
import { MdDelete } from "react-icons/md";
import { MdEdit } from "react-icons/md";
import { downloadfile, getfilesurl, deletefile, saveFile, deletedoctype } from "../tools/filehandler";
import { getserverurl, getfilestoragelocation } from '../dbconnector/connector';
import { confirmAlert } from 'react-confirm-alert';
import { CgSoftwareUpload } from 'react-icons/cg';
import { FaFolderPlus } from 'react-icons/fa';



export function TreeItem({ rights, translation, user, id, title, dateuploaded, folder, type, events, children }) {
  const [isOpen, setIsOpen] = useState(false);
  const t = translation;
  const [deleting, setdeleting] = useState(false);
  const [idcard, setId] = useState([]);
  const [filetype, setFiletype] = useState(0);
  const [serverurl, setfilesurl] = useState(getfilestoragelocation());
  const docs = [{ uri: "no file selected" }];


  const clicktreenode = (folder, id, children, title, dateuploaded) => {
    if (type === -1) {
      document.getElementById("coverAll").style.display = 'block'
    }
    else {
      setFiletype(id)
      if (folder && (document.getElementById("coverAll").style.display === 'none' || document.getElementById("coverAll").style.display === "")) {
        setIsOpen(!isOpen)
      } else if (!folder) {
        loaddocument(id, title, dateuploaded)
      }
    }
  }
  const loaddocument = (id, title) => {
    //TODO : replace hardcode uri to https://sam-assist.com:9000/
    let docs = { uri: serverurl + id }
    document.getElementById("displayedfileName").innerText = t('filename') + ": '" + title + "' |=> " + t('date uploaded') + ": '" + dateuploaded + "'"
    console.log("docs.uri :", docs.uri)
    document.getElementById("embedtag_new").src = docs.uri
  }

  const deletefilehandler = (id, type) => {
    
    if (type !== undefined) {
      deletefile(id, type)
    } else {
      deletefiletype(id)
    }
  }
  const deletefile = (id, type) => {
    console.log(id, type)

    const options = {
      title: t('Delete?'),
      message: t('SURETODELETEFILE'),
      buttons: [
        {
          label: 'Yes',
          onClick: () => {

            deletefile(id, type).then((res) => {
              events.loaddocumenttypes();
              events.cleariframe();
              setdeleting(false);
            })
          }
        },
        {
          label: 'No',
            onClick: () => {
              setdeleting(false);
          }
        }
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      keyCodeForClose: [8, 32],
      overlayClassName: "overlay-custom-class-name"
    };
    if (deleting === false) {
      setdeleting(true);
      confirmAlert(options);
    }
  }
  const deletefiletype = (id) => {
    console.log(id)

    const options = {
      title: t('Delete?'),
      message: t('SURETODELETEFILETYPE'),
      buttons: [
        {
          label: 'Yes',
          onClick: () => {

            deletedoctype(id).then((res) => {
              events.loaddocumenttypes();
              events.cleariframe();
              setdeleting(false);
            })
          }
        },
        {
          label: 'No',
           onClick: () => {
              setdeleting(false);
          }
        }
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      keyCodeForClose: [8, 32],
      overlayClassName: "overlay-custom-class-name"
    };
    if (deleting === false) {
      console.log("ddddddddddddddddddddddddddddddddddddd")
      setdeleting(true);
      confirmAlert(options);
    }
  }

  const renameFileType = (id, description) => {
    events.EditdocumentType(id, description)
  }
  const uploadnewfile = (e) => {

    setId(pre => [...pre, ...e.target.files]);

  }
  const setFiletypeId = (id) => {
    setFiletype(id)
    //console.log("filetype : ", id)

  }

  useEffect(() => {
    if (idcard.length > 0) {
      idcard.forEach((item) => {
        console.log("filetype =", filetype)
        saveFile(item, filetype, user.id).then(res => {

        })
      })

      setTimeout(() => {
        setId([])
        setFiletype([])
        events.loaddocumenttypes();
      }, 1000);
    }
  }, [idcard]);


  return (
    <div>
      {/* <div id="Bestandopladen" className="dropdownitem" > <input className='cardpicker' id="uploadContract" multiple type='file' accept='*.*' ></input></div> */}
      <div className="list-item" onClick={() => clicktreenode(folder, id, children, title, dateuploaded)}>
        <div >{children ? (isOpen ? <FaRegFolderOpen className="treeitem" /> : (children && children.length > 0 ? <RiFolderCheckFill className="treeitem" /> : <RiFolderFill className="treeitem" />)) : (folder ? <RiFolderFill className="treeitem" /> : (type === -1 ? <FaFolderPlus></FaFolderPlus> : <HiDocumentText className="treeitem" />))}
        </div>
        <div className={folder ? "list-item-subtree list-item-subtree-header" : "list-item-subtree-file"}>
          <div className="list-item-subtree">{title}</div>
          <div className="list-item-subtree"> {dateuploaded}</div>
          <div className="list-item-subtree" ><div style={rights === 2 ? { display: 'block' } : { display: 'none' }}><MdDelete onClick={() => deletefilehandler(id, type)}></MdDelete></div></div>
          <div className="list-item-subtree" ><div style={!folder ? { display: 'none' } : { display: 'block' }}><MdEdit onClick={() => renameFileType(id, title)} /></div></div>
        </div>
      </div>
      {isOpen && <div><div style={rights === 4 ? { display: 'none' } : { display: 'block' }}><label for="uploadContract" className='custom-file_upload' onClick={() => setFiletypeId(id)}><CgSoftwareUpload className="custom-file_icon" /> {t('UploadFile')}</label>
        <input style={{ visibility: 'hidden' }} id="uploadContract" multiple type='file' accept='*.*' onChange={(e) => uploadnewfile(e)}></input></div>
        <div className="list-item-subtree">{children}</div></div>}
    </div>
  );
}

export function TreeView({ children }) {
  return <>{children}</>;
}



